import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedMaterialModule } from 'app/shared/shared-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TgssDatepickerComponent } from './tgss-datepicker.component';



@NgModule({
  imports: [
    CommonModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],
  declarations: [TgssDatepickerComponent],
  exports: [TgssDatepickerComponent]
})
export class TgssDatepickerModule { }
